/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Tim Porritt
 * Created: 03/12/21
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { useAuth } from './useAuth';
import { useQuery } from '@/utils/hooks/useQuery';
import { Center, Spinner, Text, VStack } from '@chakra-ui/react';

const LoginCallback = () => {
    const params = useQuery();
    const navigate = useNavigate();
    const { setAccessToken, setError } = useAuth();

    useEffect(() => {
        if (params['accessToken']) {
            const relayState = params['RelayState'];
            if (relayState) {
                navigate(relayState, { replace: true });
            }
            setAccessToken(params['accessToken']);
            navigate('/', { replace: true });
        } else if (params['error']) {
            const err = params['error'];
            if (typeof err === 'string') {
                try {
                    setError(JSON.parse(atob(decodeURIComponent(err))));
                } catch (e) {
                    setError(err);
                }
            } else {
                setError(err);
            }
            navigate('/', { replace: true });
        } else {
            navigate('/', { replace: true });
        }
    }, [params]);

    return (
        <Center>
            <VStack spacing={4} m={8}>
                <Text fontSize="lg">Signing in</Text>
                <Spinner size="xl" thickness="4px" color="blue.500" />
            </VStack>
        </Center>
    );
};

export default LoginCallback;
